<template>
  <div class="title-bar-container">
    <rich-card class="title-bar">
      <header slot="header" class="title-bar-wrap">
        <div v-if="locateErr" class="locate-err-tips">
          <i class="icon-lingdang"></i>
          {{ gettext('当前定位失败') }}
        </div>
        <i
          v-if="(needBack || showBack) && !cancelText"
          class="title-bar-back fusion-r_fusion_icon_back_ios"
          @click="goBack"
        />
        <div class="title-bar-main-wrap">
          <h2 class="title-bar-main">{{ title }}</h2>
          <i v-if="iconClass" class="title-bar-icon" :class="iconClass" @click.stop="iconClick" />
        </div>

        <h2 v-if="actionText" class="title-bar-action" @click="actionHandler">
          {{ actionText }}
        </h2>
        <h2 v-if="cancelText" class="title-bar-cancel" @click="cancelHandler">
          {{ cancelText }}
        </h2>
      </header>
    </rich-card>
  </div>
</template>

<script>
import { trackEvent } from '@/common/utils/log'
export default {
  props: {
    title: {
      type: String,
      required: true,
    },
    showBack: {
      type: Boolean,
      required: false,
      default: false,
    },
    needBack: {
      type: Boolean,
      required: false,
      default: false,
    },
    // 判断是否跳回HOME页
    backHome: {
      type: Boolean,
      required: false,
      default: false,
    },
    locateErr: {
      type: Boolean,
      required: false,
      default: false,
    },
    actionText: {
      type: String,
      default: '',
    },
    cancelText: {
      type: String,
      default: '',
    },
    action: {
      type: Function,
      default: () => {},
    },
    cancel: {
      type: Function,
      default: () => {},
    },
    useNative: {
      type: Boolean,
      default: false,
    },
    iconClass: {
      type: String,
      default: '',
    },
    iconClick: {
      type: Function,
      default: () => {
        console.log('iconClick')
      },
    },
  },
  methods: {
    async goBack() {
      this.$emit('back')
      trackEvent('sailing_b_x_new_leads_create_page_ck', {
        step: `新建商机-返回取消按钮`,
        action: 'click',
        button_type: '2',
      })
      if (this.needBack) {
        this.$router.back({
          useNative: this.useNative,
        })
      }
    },
    actionHandler() {
      this.action()
    },
    cancelHandler() {
      this.cancel()
    },
  },
}
</script>
<style lang="scss">
.title-bar-container {
  padding-top: var(--barheight);
  background-color: #fff;
}
.title-bar {
  position: relative;
  height: 100px;
  background: $color-white;
  .title-bar-main-wrap {
    display: flex;
    .title-bar-icon {
      font-size: 36px;
      position: relative;
      top: 7px;
    }
  }
  &-wrap {
    height: 100px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  &-main {
    font-size: $fontsize-large;
    line-height: 1.5;
  }
  &-action {
    position: absolute;
    top: 50%;
    right: 10px;
    transform: translateY(-50%);
    font-size: $fontsize-large;
    color: $color-orange;
    padding: 20px;
    background-color: #fff;
  }
  &-cancel {
    position: absolute;
    top: 50%;
    left: 10px;
    transform: translateY(-50%);
    font-size: $fontsize-large;
    color: $color-grey;
    padding: 20px;
    background-color: #fff;
  }
  .locate-err-tips {
    position: fixed;
    top: 26px;
    right: 0;
    display: inline-block;
    padding: 10px;
    padding-right: 30px;
    color: $color-white;
    font-size: $fontsize-small;
    background: $color-light-red;
  }
  &-back {
    position: absolute;
    top: 50%;
    left: 20px;
    transform: translateY(-50%);
    font-size: 36px;
    padding: 20px;
  }
}
</style>
